// src/config.js — Centralized configuration for Verified by GS1 frontend
// All process.env.* values are string literals injected at build time via webpack DefinePlugin.
// Compare boolean flags with === 'true'.

export const NODE_ENV = process.env.NODE_ENV || 'production'

// ---- OIDC (Keycloak) ----
export const OIDC_ENABLED = process.env.OIDC_ENABLED === 'true'
export const OIDC_ISSUER = process.env.OIDC_ISSUER || ''
export const OIDC_CLIENT_ID = process.env.OIDC_CLIENT_ID || ''
export const OIDC_SCOPE = process.env.OIDC_SCOPE || 'openid'
export const OIDC_TOKEN_URL =
  process.env.OIDC_TOKEN_URL || '/api/token_service/oauth/oidc/token'

/**
 * OIDC redirect URI — the public callback URL where the authorization server
 * redirects the user after authentication.  Must be registered in the OIDC client.
 */
export const OIDC_REDIRECT_URI =
  typeof window !== 'undefined' ? window.location.origin + '/callback' : ''

// ---- Legacy SSO / OAuth ----
export const OAUTH_TOKEN_URL =
  process.env.OAUTH_TOKEN_URL || '/api/token_service/oauth/token'
export const OAUTH_REVOKE_URL =
  process.env.OAUTH_REVOKE_URL || '/api/token_service/oauth/token/revoke'
export const OAUTH_AUTH_URL = process.env.OAUTH_AUTH_URL || ''
export const SSO_LOGOUT_URL = process.env.SSO_LOGOUT_URL || ''

// ---- General ----
export const AUTH_ENABLED = process.env.AUTH_ENABLED !== 'false'
export const SIMBA_SERVICE_BASE_URL = process.env.SIMBA_SERVICE_BASE_URL || ''
export const AUTH_URL = process.env.AUTH_URL || ''

// Legacy OAuth client id (hard-coded, not environment-specific)
export const CLIENT_ID = 'JIkkOBJ2YoLOqe2DXufmnfoKyJRUY6h2'

export default {
  NODE_ENV,
  OIDC_ENABLED,
  OIDC_ISSUER,
  OIDC_CLIENT_ID,
  OIDC_SCOPE,
  OIDC_TOKEN_URL,
  OIDC_REDIRECT_URI,
  OAUTH_TOKEN_URL,
  OAUTH_REVOKE_URL,
  OAUTH_AUTH_URL,
  SSO_LOGOUT_URL,
  AUTH_ENABLED,
  SIMBA_SERVICE_BASE_URL,
  AUTH_URL,
  CLIENT_ID
}



// WEBPACK FOOTER //
// ./src/config.js